import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserDetailsComponent } from './user-details/user-details.component';
import { AuthGuard } from '../guards/auth.guard';
import { UserMessagesComponent } from './user-messages/user-messages.component';
import { ClientSitesComponent } from '../client/client-sites/client-sites.component';
import { UserDynamicFormsComponent } from './user-dynamic-forms/user-dynamic-forms.component';
import {UserTasksComponent} from "./user-tasks/user-tasks.component";
import { BackgroundExportsComponent } from './background-exports/background-exports.component';
import { AccountAccessComponent } from './account-access/account-access.component';

const routes: Routes = [
  {
    path: 'user',
    canActivate: [
      AuthGuard
    ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/user/details'
      },
      {
        path: 'details', component: UserDetailsComponent
      },
      {
        path: 'messages', component: UserMessagesComponent
      },
      {
        path: 'tasks', component: UserTasksComponent
      },
      {
        path: 'dynamic-forms', component: UserDynamicFormsComponent
      },
      {
        path: 'accessible-sites', component: ClientSitesComponent
      },
      {
        path: 'background-exports', component: BackgroundExportsComponent
      },
      {
        // Membership request status (SC-301). A personal surface, so it carries no feature permission:
        // the parent user route's AuthGuard is the whole gate. Requiring a permission here would lock a
        // pending user out of the one page that explains their own situation.
        path: 'account-access', component: AccountAccessComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {}
